import React from "react";
import PropTypes from "prop-types";
import { Bar as HorizontalBar } from "react-chartjs-2";
import { Chart as ChartJS, CategoryScale, LinearScale, BarElement, Tooltip, Legend } from "chart.js";
import ChartDataLabels from "chartjs-plugin-datalabels";
import { FormatAsDollars } from "./../../../utils/Helpers/Format";

ChartJS.register(CategoryScale, LinearScale, BarElement, Tooltip, Legend, ChartDataLabels);

const CostToOwnComparisonChart = ({
     chartData,
     customLegend,
     displayEvCostBreakdownOption,
     displayEvCostBreakdown
}) => {
     const options = {
          indexAxis: "y",
          maintainAspectRatio: false,
          animation: {
               duration: 0
          },
          scales: {
               x: {
                    stacked: true,
                    ticks: {
                         callback: function (value) {
                              return FormatAsDollars(value);
                         },
                         beginAtZero: true,
                         color: "#191919"
                    }
               },
               y: {
                    stacked: true,
                    ticks: {
                         color: "#191919",
                         font: {
                              weight: 400
                         }
                    }
               }
          },
          layout: {
               padding: {
                    right: 75
               }
          },
          plugins: {
               tooltip: {
                    callbacks: {
                         label: function (context) {
                              const value = context.dataset.data[context.dataIndex];
                              const label = context.dataset.label || "";
                              return " " + label + ": " + FormatAsDollars(value);
                         },
                         title: function (tooltipItems) {
                              const total = tooltipItems.reduce(function (acc, item) {
                                   return acc + item.parsed.x;
                              }, 0);
                              return tooltipItems[0].label + ": " + FormatAsDollars(total);
                         }
                    }
               },
               legend: {
                    position: "bottom",
                    onClick: function (e) {
                         e.stopPropagation();
                    },
                    display: customLegend ? false : true
               },
               datalabels: {
                    formatter: (value, ctx) => {
                         let datasets = ctx.chart.data.datasets;
                         if (ctx.datasetIndex === datasets.length - 1) {
                              let sum = 0;
                              datasets.forEach((dataset) => {
                                   sum += dataset.data[ctx.dataIndex];
                              });
                              return FormatAsDollars(sum);
                         } else {
                              return "";
                         }
                    },
                    align: "end",
                    anchor: "end",
                    color: "#191919",
                    font: {
                         weight: 4400
                    }
               }
          }
     };

     return (
          <>
               <HorizontalBar data={chartData} height={212} options={options} />
          </>
     );
};

export default CostToOwnComparisonChart;

CostToOwnComparisonChart.propTypes = {
     carNames: PropTypes.array,
     carCosts: PropTypes.array,
     displayEvCostBreakdownOption: PropTypes.bool,
     displayEvCostBreakdown: PropTypes.bool,
     displayFuelOnly: PropTypes.bool
};
